import { issueVisibility, workPhaseType } from "../enums";
import { serviceHelper } from "../../services/helper";

export const getter = {
  getTokenBearer,
  getRoleActions,
  getWorkPhase,
  getRoleId,
  isIssueVisible,
  isActionAllowed,
  getViewpointImageSource,
  getViewpointThumbnailUrl,
  getIssueThumbnailUrl,
};

function getTokenBearer() {
  const token = JSON.parse(localStorage.getItem("token"));
  return token?.bearer;
}

function getRoleActions(project, user) {
  if (user.id === undefined) {
    return null;
  }
  return project.actions;
}

function getWorkPhase(work) {
  const workPhase = Object.values(workPhaseType).find((w) => w.value === work);
  return workPhase.label;
}

function getRoleId(project, userId) {
  const role = project.collaboratorRoles.find(
    (r) => r.collaboratorId === userId
  );
  return role ? role.roleDefinitionId : null;
}

function isIssueVisible(issue, userId, roleId) {
  return (
    issue.creatAuthorId === userId ||
    issue.reviewerId === userId ||
    (issue.assignedCollaboratorIds &&
      issue.assignedCollaboratorIds.includes(userId)) ||
    issue.visibility === issueVisibility.PUBLIC.value ||
    (issue.visibility === issueVisibility.RESTRICTED.value &&
      issue.allowedCollaboratorGroups.includes(roleId))
  );
}

function isActionAllowed(roleActions, action) {
  const actionMap = roleActions.find((a) => a.action === action);
  if (!actionMap) return false;
  return actionMap.isAllowed;
}

// The api no longer hands out pre-signed image links. A client addresses an image by the id of the
// entity it belongs to and authenticates with the project resource token, which the api issues once
// per project and which is valid for every image of that project.
function getResourceUrl(path, resourceToken) {
  if (!resourceToken || !resourceToken.token) return "";
  return `${serviceHelper.getBaseURL()}resource/authenticated/${path}?token=${encodeURIComponent(
    resourceToken.token
  )}`;
}

// The *ImageId properties only tell whether the api has an image at all - the url is built from the
// id of the viewpoint, not from the id of the image.
function getViewpointThumbnailUrl(viewpoint, resourceToken) {
  if (!viewpoint || !viewpoint.id || !viewpoint.thumbnailImageId) return "";
  return getResourceUrl(`viewpoint/${viewpoint.id}/thumbnail`, resourceToken);
}

function getIssueThumbnailUrl(issue, resourceToken) {
  if (!issue || !issue.id || !issue.thumbnailImageId) return "";
  return getResourceUrl(`issue/${issue.id}`, resourceToken);
}

// The api generates the thumbnail of a viewpoint on its own, so a viewpoint created in Archicad has
// none for a while. As long as that is the case the snapshot taken in Archicad stands in for it.
function getViewpointImageSource(viewpoint, localImages, resourceToken) {
  if (!viewpoint) return "";

  const thumbnailUrl = getViewpointThumbnailUrl(viewpoint, resourceToken);
  if (thumbnailUrl) return thumbnailUrl;
  if (viewpoint.localImage) return viewpoint.localImage;

  const localImage = (localImages || []).find(
    (l) => l.imageId === viewpoint.imageId
  );
  return localImage ? localImage.img : "";
}
